// Shared by middleware (edge) and _app (client), so it must not import next/server.
export function isPublicPath(pathname: string) {
  return (
    [
      '/login',
      '/create-account',
      '/forgot-password',
      '/announcements',
      '/announcement-detail',
      '/announcement-dashboard',
      '/news-insights',
      '/research',
      '/',
      '/terms',
      '/view-dns',
      '/maintainance-mode',
      '/test-meta',
      '/signin-blocked'
    ].includes(pathname) ||
    pathname.includes('announcement') ||
    pathname === '/corporate' ||
    pathname.startsWith('/corporate/')
  )
}
